import { useEffect } from 'react';
import { buildLocalizeRoute } from '../../../helpers/languageHelper';
import { useNavigate, useLocation } from 'react-router-dom';

export const LanguageHandler = () => {
	const navigate = useNavigate();
	const location = useLocation();
	useEffect(() => {
		const originalPath = location.pathname.replace(/^\//, '') + location.search + location.hash;
		navigate(buildLocalizeRoute(originalPath), { replace: true });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};

export default LanguageHandler;
